import { ApiClient } from "./ApiClient";

export const apiClient = new ApiClient();
